import {
    faRocket,
    faFileAlt,
    faUsers,
    faBoxesStacked,
    faChartLine,
    faCreditCard,
    faCogs,
    faShieldHalved,
    faGaugeHigh,
    faLayerGroup,
    faPuzzlePiece,
    faUserPlus,
    faPalette,
    faGlobe,
    faKey,
    faEnvelope,
    faQuestion,
    type IconDefinition,
} from '@fortawesome/free-solid-svg-icons'

const iconMap: Record<string, IconDefinition> = {
    faRocket,
    faFileAlt,
    faUsers,
    faBoxesStacked,
    faChartLine,
    faCreditCard,
    faCogs,
    faShieldHalved,
    faGaugeHigh,
    faLayerGroup,
    faPuzzlePiece,
    faUserPlus,
    faPalette,
    faGlobe,
    faKey,
    faEnvelope,
}

export function resolveIcon(name: string): IconDefinition {
    return iconMap[name] || faQuestion
}
